let clientId = null;

function onRecaptchaLoadCallback() {
  clientId = grecaptcha.render("inline-badge", {
    sitekey: window.captchaSitekey,
    badge: "inline",
    size: "invisible",
  });
}
function loadReCaptcha() {
  if (window.captchaLoaded) {
    return;
  }

  const head = document.getElementsByTagName("head")[0];
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.src =
    "https://www.google.com/recaptcha/api.js?render=explicit&onload=onRecaptchaLoadCallback";
  head.appendChild(script);

  window.captchaLoaded = true;
}

document.addEventListener("DOMContentLoaded", function () {
  function handleCaptchaSubmit(event, formEl) {
    event.preventDefault();
    const id = formEl.getAttribute("id");
    grecaptcha.ready(function () {
      grecaptcha.execute(clientId, { action: id }).then(function (token) {
        document.querySelector("input.captcha-token").value = token;
        formEl.submit();
      });
    });
  }

  const captchaForms = document.querySelectorAll(".captchaForm");
  captchaForms.forEach(function (form) {
    form.addEventListener("submit", function (event) {
      handleCaptchaSubmit(event, this);
    });
  });

  document.querySelectorAll(".footerContactForm input").forEach(function (input) {
    input.addEventListener("focus", function () {
      loadReCaptcha();
    });
  });

  if (typeof captchaPage !== "undefined") {
    loadReCaptcha();
  }
});
